import { Snippet } from 'components/snippet';
import { WIDGETS_LIB_LINK } from 'constants/links';
import {
    WIDGET_ACCOUNT_ID_PLACEHOLDER,
    WIDGET_DISPLAY_CODE_PLACEHOLDER,
    WIDGET_LIBRARY_CODE_PLACEHOLDER,
    WidgetPlatform,
} from 'constants/widgets';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { Widget } from 'types/domain';

const WidgetInstructions = (props: {
    platform: WidgetPlatform;
    steps: string[];
    inPortal: boolean;
    widget: Widget | null;
    setupType?: 'widget' | 'library';
}) => {
    const { platform, steps, inPortal, setupType = 'widget', widget } = props;
    const { accountAid } = useCurrentAccount();

    const widgetDisplayCodePlaceholder = (platform: WidgetPlatform, widget: Widget | null) => {
        switch (platform) {
            case WidgetPlatform.wix:
                return widget?.display_id;
            case WidgetPlatform.wordpress:
                return `[givebutter-widget id="${widget?.display_id}"]`;
            default:
                return `<givebutter-widget id="${widget?.display_id}"></givebutter-widget>`;
        }
    };

    let stepCount = 0;
    return (
        <>
            {steps.map((instruction, index) => {
                const key = `instruction-${index}`;

                if (instruction === WIDGET_LIBRARY_CODE_PLACEHOLDER) {
                    const widgetLibraryCode =
                        platform === WidgetPlatform.wix
                            ? `${WIDGETS_LIB_LINK}?acct=${accountAid}`
                            : `<script async src="${WIDGETS_LIB_LINK}?acct=${accountAid}&p=${platform}"></script>`;

                    return (
                        <div key={key}>
                            <Snippet
                                text={widgetLibraryCode}
                                copyProps={{ label: 'Copy' }}
                                inPortal={inPortal}
                            />
                        </div>
                    );
                }

                if (instruction === WIDGET_DISPLAY_CODE_PLACEHOLDER) {
                    return (
                        widget !== undefined && (
                            <div key={key}>
                                <Snippet
                                    text={widgetDisplayCodePlaceholder(platform, widget)}
                                    copyProps={{ label: 'Copy' }}
                                    inPortal={inPortal}
                                />
                            </div>
                        )
                    );
                }

                if (instruction === WIDGET_ACCOUNT_ID_PLACEHOLDER) {
                    return (
                        <div key={key}>
                            <Snippet
                                text={accountAid}
                                copyProps={{ label: 'Copy' }}
                                inPortal={inPortal}
                            />
                        </div>
                    );
                }

                return (
                    <div key={key} className="flex gap-2">
                        <p>{++stepCount}.</p>
                        <p dangerouslySetInnerHTML={{ __html: instruction }} />
                    </div>
                );
            })}
            {setupType === 'library' && (
                <div key={'final'} className="flex gap-2">
                    <p>{++stepCount}.</p>
                    <p>
                        {platform === WidgetPlatform.wix
                            ? `You'll be able to select "Embed" on any widget from the Givebutter dashboard and follow the provided instructions to add it to your website.`
                            : `Once the library is installed, you'll be able to select "Embed" on any widget from the Givebutter dashboard and follow the provided instructions to add it to your website.`}
                    </p>
                </div>
            )}
        </>
    );
};

export { WidgetInstructions };
